export default {"src":"/_next/static/media/check.31926045.svg","height":10,"width":9,"blurWidth":0,"blurHeight":0};